import {
    JCENVIRO_GET_WASTE_DISPOSAL_LIST,
    JCENVIRO_ADD_WASTE_DISPOSAL_SITE,
    JCENVIRO_EDIT_WASTE_DISPOSAL_SITE,
    JCENVIRO_REMOVE_WASTE_DISPOSAL_SITE
} from "./types";
import firebase from "firebase/app";
import moment from "moment";
export const getDisposalSites = () => {
    return dispatch => {
        dispatch({ type: JCENVIRO_GET_WASTE_DISPOSAL_LIST.REQUEST });

        try {
            firebase.auth().onAuthStateChanged(user => {
                if (user === null) {
                    dispatch({ type: JCENVIRO_GET_WASTE_DISPOSAL_LIST.FAIL });
                } else {
                    firebase
                        .database()
                        .ref("/collections/waste_disposal_sites")
                        .on("value", snapshot => {
                            dispatch({
                                type: JCENVIRO_GET_WASTE_DISPOSAL_LIST.SUCCESS,
                                payload: snapshot.val()
                            });
                        });
                }
            });
        } catch (e) {
            dispatch({ type: JCENVIRO_GET_WASTE_DISPOSAL_LIST.FAIL });
        }
    };
};

export const addDisposalSite = site => {
    const siteJson = {
        added_by: "",
        create_timestamp: moment().format("YYYY-MM-DD hh:mm:s"),
        disposal_site: site
    };
    return dispatch => {
        dispatch({ type: JCENVIRO_ADD_WASTE_DISPOSAL_SITE.REQUEST });

        try {
            firebase.auth().onAuthStateChanged(user => {
                if (user === null) {
                    dispatch({ type: JCENVIRO_ADD_WASTE_DISPOSAL_SITE.FAIL });
                } else {
                    firebase
                        .database()
                        .ref("/collections/waste_disposal_sites")
                        .child(site)
                        .set(siteJson);
                    dispatch({
                        type: JCENVIRO_ADD_WASTE_DISPOSAL_SITE.SUCCESS
                    });
                }
            });
        } catch (e) {
            dispatch({ type: JCENVIRO_ADD_WASTE_DISPOSAL_SITE.FAIL });
        }
    };
};

export const editDisposalSite = (key, site) => {
    const siteJSON = {
        disposal_site: site
    };
    return dispatch => {
        dispatch({ type: JCENVIRO_EDIT_WASTE_DISPOSAL_SITE.REQUEST });

        try {
            firebase.auth().onAuthStateChanged(user => {
                if (user === null) {
                    dispatch({ type: JCENVIRO_EDIT_WASTE_DISPOSAL_SITE.FAIL });
                } else {
                    firebase
                        .database()
                        .ref("/collections/waste_disposal_sites")
                        .child(key)
                        .update(siteJSON);

                    dispatch({
                        type: JCENVIRO_EDIT_WASTE_DISPOSAL_SITE.SUCCESS
                    });
                }
            });
        } catch (e) {
            dispatch({ type: JCENVIRO_EDIT_WASTE_DISPOSAL_SITE.FAIL });
        }
    };
};

export const removeDisposalSite = key => {
    return dispatch => {
        dispatch({ type: JCENVIRO_REMOVE_WASTE_DISPOSAL_SITE.REQUEST });

        try {
            firebase.auth().onAuthStateChanged(user => {
                if (user === null) {
                    dispatch({
                        type: JCENVIRO_REMOVE_WASTE_DISPOSAL_SITE.FAIL
                    });
                } else {
                    firebase
                        .database()
                        .ref("/collections/waste_disposal_sites")
                        .child(key)
                        .remove();
                    dispatch({ type: JCENVIRO_REMOVE_WASTE_DISPOSAL_SITE.SUCCESS });
                }
            });
        } catch (e) {
            dispatch({ type: JCENVIRO_REMOVE_WASTE_DISPOSAL_SITE.FAIL });
        }
    };
};
